export default function HrDashboard() {
  return (
    <div className="space-y-6">
      <h1 className="text-3xl font-bold text-gray-700">HR Dashboard</h1>
      <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
        <div className="bg-blue-500 text-white p-6 rounded-xl shadow hover:scale-105 transform transition cursor-pointer">
          <h2 className="text-xl font-semibold">Employees</h2>
          <p className="mt-2">Manage all employees</p>
        </div>
        <div className="bg-green-500 text-white p-6 rounded-xl shadow hover:scale-105 transform transition cursor-pointer">
          <h2 className="text-xl font-semibold">Attendance</h2>
          <p className="mt-2">Track attendance</p>
        </div>
        <div className="bg-purple-500 text-white p-6 rounded-xl shadow hover:scale-105 transform transition cursor-pointer">
          <h2 className="text-xl font-semibold">Payroll</h2>
          <p className="mt-2">Manage salaries and payslips</p>
        </div>
        <div className="bg-yellow-500 text-white p-6 rounded-xl shadow hover:scale-105 transform transition cursor-pointer">
          <h2 className="text-xl font-semibold">Reports</h2>
          <p className="mt-2">Generate HR reports</p>
        </div>
      </div>
    </div>
  );
}
